<div class="modal-header bigger-header">
	<h1 class="modal-title bold-text lh-1" id="newsletterSignupModalLabel">Sign up for our newsletter.</h1>
	<a href="javascript:void(0);" type="button" class="close-btn" (click)="close()" aria-label="Close"><fa-icon [icon]="['fas', 'xmark']"></fa-icon></a>
</div>
<div class="modal-body">
	<form [formGroup]="formGroup" *ngIf="formGroup">
		<div class="row">
			<div class="col-12 col-sm-6 mb-4">
				<label for="firstName" class="form-label required" [class.invalid]="err.firstName">First Name</label>
				<input type="text" class="form-control" id="firstName" formControlName="firstName" [class.invalid]="err.firstName">
				<p class="font-size-075 bold-text red-text" *ngIf="err.firstName?.required">Please enter your first name</p>
			</div>
			<div class="col-12 col-sm-6 mb-4">
				<label for="lastName" class="form-label required" [class.invalid]="err.lastName">Last Name</label>
				<input type="text" class="form-control" id="lastName" formControlName="lastName" [class.invalid]="err.lastName">
				<p class="font-size-075 bold-text red-text" *ngIf="err.lastName?.required">Please enter your last name</p>
			</div>
		</div>
		<div class="row">
			<div class="col mb-4">
				<label for="companyName" class="form-label">Company Name</label>
				<input type="text" class="form-control" id="companyName" formControlName="companyName">
			</div>
		</div>
		<div class="row">
			<div class="col mb-4">
				<label for="emailAddress" class="form-label required" [class.invalid]="err.email">Email Address</label>
				<input type="email" class="form-control" id="emailAddress" formControlName="email" [class.invalid]="err.email">
				<p class="font-size-075 bold-text red-text" *ngIf="err.email?.required || err.email?.email">Please enter a valid email address in the format <br>name&#64;company.com</p>
			</div>
		</div>
		<div class="row">
			<div class="col mb-4">
				<label for="phone" class="form-label" [class.invalid]="err.phone">Phone</label>
				<div ngbDropdown class="input-group" [class.invalid]="err.phone">
					<button ngbDropdownToggle class="btn btn-form-field left-side-btn" type="button" aria-expanded="false">{{ form.country.value?.code }}</button>
					<ul class="dropdown-menu scroll-dropdown" ngbDropdownMenu>
						<div class="scrolling-area">
							<li *ngFor="let country of defaultCountries" (click)="chooseCountry(country)"><a ngbDropdownItem href="javascript:void(0)">{{ country.name }} {{ country.code }}</a></li>
							<li>
								<hr class="dropdown-divider">
							</li>
							<li *ngFor="let country of countries" (click)="chooseCountry(country)"><a ngbDropdownItem href="javascript:void(0)">{{ country.name }} {{ country.code }}</a></li>
						</div>
					</ul>
					<input type="tel" class="form-control" id="phone" formControlName="phone" [maskito]="{ mask: phoneMasksMap[form.country.value?.id] }" [validation]="true" [class.invalid]="err.phone" [hiddenInput]="true">
				</div>
				<p class="font-size-075 bold-text red-text" *ngIf="err.phone?.required || err.phone?.mask">Please enter a valid phone number.</p>
			</div>
		</div>
		<div class="row d-flex align-items-center">
			<div class="col">
				<p class="semibold-text green-text mb-0" *ngIf="showSuccessMessage">Thank you for signing up.</p>
			</div>
			<div class="col-auto text-end">
				<button type="button" class="btn btn-primary py-2 px-5" (click)="submit()" [disabled]="submitDisabled">{{ submitText }}</button>
			</div>
		</div>
	</form>
</div>
